import { render, staticRenderFns } from "./formIdentitas.vue?vue&type=template&id=7a5c0b20&"
import script from "./formIdentitas.vue?vue&type=script&lang=js&"
export * from "./formIdentitas.vue?vue&type=script&lang=js&"
import style0 from "./formIdentitas.vue?vue&type=style&index=0&id=7a5c0b20&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports